<template>
  <div class="newYuesaoC" v-if="!loading">
    <div class="newYuesaoC_header" v-if="workerInfo && workerInfo.uid">
      <div class="showCertBg">
        <i
          :class="[identityLabelObj && identityLabelObj.icon]"
          @click="gotoService('ServiceDetail')"
        ></i>
      </div>
      <div class="yuesao_info_bg">
        <div class="yuesao_info">
          <img
            :src="$$viewImageInCenter(workerInfo.headImage, 200, 200)"
            alt=""
            class="yuesao_info_header"
            v-if="workerInfo.headImage"
            @click="showImage([workerInfo.headImage], 0)"
          />
          <img
            src="../../../assets/images/newYuesao/avatar.png"
            alt=""
            class="yuesao_info_header"
            v-else
          />

          <div
            class="yuesao_info_content"
            v-if="
              workerInfo.lightExperienceList &&
              workerInfo.lightExperienceList.length > 0
            "
          >
            <div class="name">{{ workerInfo.workerName }}</div>
            <div class="Info">
              <div class="Info_item">{{ workerInfo.age }}岁</div>
              <div class="Info_item item_elli">
                {{ workerInfo.place }}
              </div>
              <div class="Info_item item_elli" v-if="workerInfo.nation">
                {{ workerInfo.nation }}
              </div>
            </div>
            <div class="label">
              <span
                class="label_item"
                v-for="(item, index) in workerInfo.lightExperienceList"
                :key="index"
                >{{ item }}</span
              >
            </div>
          </div>
          <div class="yuesao_info_content" v-else>
            <div class="columnName">
              {{ workerInfo.workerName }}
            </div>
            <div class="columnInfo">
              <div class="Info_item infosix">年龄：{{ workerInfo.age }}岁</div>
              <div class="Info_item infosix">籍贯：{{ workerInfo.place }}</div>
              <div class="Info_item infosix" v-if="workerInfo.nation">
                民族：{{ workerInfo.nation }}
              </div>
            </div>
          </div>
        </div>
        <div class="yuesao_motto" v-if="workerInfo.motto">
          <i></i>
          <span>
            {{ workerInfo.motto }}
          </span>
        </div>
      </div>
      <div class="yuesao_cert">
        <certification :backTone="workerInfo.backTone"></certification>
      </div>
    </div>
    <div class="newYuesaoC_box record">
      <div class="h_title">
        <h2>个人档案</h2>
      </div>
      <div class="items">
        <div class="item" v-if="workerInfo.workAge">
          <span>从业年限：</span>
          <span class="item_r">{{ workerInfo.workAge }}年</span>
        </div>
        <div class="item" v-if="workerInfo.servicesNumbers > 0">
          <span>带过宝宝：</span>
          <span class="item_r">{{ workerInfo.servicesNumbers }}位</span>
        </div>
        <div class="item" v-if="workerInfo.education">
          <span>学历：</span
          ><span class="item_r">{{ workerInfo.education }}</span>
        </div>
        <div class="item" v-if="workerInfo.chineseLevel">
          <span>普通话：</span
          ><span class="item_r">{{ workerInfo.chineseLevel }}</span>
        </div>
        <div class="item" v-if="workerInfo.constellation">
          <span>星座：</span
          ><span class="item_r">{{ workerInfo.constellation }}</span>
        </div>
        <div
          class="item"
          v-if="workerInfo.zodiac && workerInfo.servicesNumbers > 0"
        >
          <span>生肖：</span><span class="item_r">{{ workerInfo.zodiac }}</span>
        </div>
        <div class="item_area" v-if="serviceAreasName">
          <span>服务区域：</span>
          <div class="itemareali">
            <div v-for="(area, index) in serviceAreasName" :key="index">
              {{ area }}
            </div>
          </div>
        </div>
      </div>
      <!-- 月嫂风采 start 图片大于4再展示滑动条-->
      <div
        class="photo_wall"
        v-if="userInfo.picUrls && userInfo.picUrls.length > 0"
      >
        <div class="photo_wall_content">
          <div class="photo_wall_items">
            <ul
              class=""
              ref="photo_wallul"
              @scroll="
                handlerTouchEnd($refs.photo_wallul, $refs.photo_wallline)
              "
            >
              <li v-for="(image, index) in userInfo.picUrls" :key="index">
                <img
                  v-lazy="$$viewImageInCenter(image, 206, 206)"
                  alt=""
                  @click="showImage(userInfo.picUrls, index)"
                />
              </li>
            </ul>
          </div>
          <div class="photo_wall_line" v-if="userInfo.picUrls.length >= 4">
            <div class="wall_line">
              <div class="line" ref="photo_wallline"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 月嫂风采 end -->
    </div>
    <div
      class="newYuesaoC_box certificate"
      v-if="workerInfo.workerCredentials.length"
    >
      <div class="h_title">
        <h2>持有证书</h2>
        <p
          v-if="workerInfo.workerHiddenCredentials.length"
          class="credentials-detail"
          @click="goCredentialsDetail"
        >
          查看证书详情
          <img src="../../../assets/images/sx_icon_more@3x.png" alt="" />
        </p>
      </div>
      <div class="certificate_items">
        <div
          class="item"
          v-for="(item, index) in workerCredentials"
          :key="index"
        >
          <img
            src="https://hzwimspic-1251601690.image.myqcloud.com/b703f6e0-7d53-11eb-955e-df4b593726f9_size_45x45"
            alt=""
            class="item_icon"
          /><span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <!-- 擅长技能 start-->
    <div
      class="newYuesaoC_box skilled"
      v-if="
        workerInfo.motherNursingList &&
        workerInfo.motherNursingList.length > 0 &&
        workerInfo.babyNursingList &&
        workerInfo.babyNursingList.length > 0
      "
    >
      <div class="h_title">
        <h2>擅长技能</h2>
        <p class="detail" @click="gotoService('EvaluationCriterion')">
          全部服务内容
          <img src="../../../assets/images/sx_icon_more@3x.png" alt="" />
        </p>
      </div>
      <div class="skilled_items">
        <div class="skilled_item">
          <p class="title">妈妈护理技能</p>
          <div
            class="item"
            v-for="(item, index) in workerInfo.motherNursingList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="skilled_item_baby">
          <p class="title">宝宝护理技能</p>
          <div
            class="item"
            v-for="(item, index) in workerInfo.babyNursingList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <!-- 擅长技能 end-->

    <!-- 月嫂履历 start-->
    <div class="newYuesaoC_box resume" v-if="workerInfo.resume">
      <div class="h_title">
        <h2>月嫂履历</h2>
      </div>
      <p class="resume_items">
        {{ workerInfo.resume }}
      </p>
    </div>
    <!-- 月嫂履历 end-->

    <!-- 服务动态 start-->
    <div class="newYuesaoC_box service" v-if="serviceList.length">
      <div class="h_title">
        <h2>服务动态</h2>
        <p
          class="detail"
          @click="goServiceDetail"
          v-if="serviceList.length > 4"
        >
          查看动态详情
          <img src="../../../assets/images/sx_icon_more@3x.png" alt="" />
        </p>
      </div>
      <p class="service_items">
        <serviceProcess
          :serviceList="serviceList"
          :shownum="4"
        ></serviceProcess>
      </p>
    </div>
    <!-- 服务动态 end-->

    <!-- 孩子王考核官点评 start -->
    <div
      class="newYuesaoC_box evaluate"
      v-if="
        workerInfo.checkerComment &&
        workerInfo.jnScore > 0 &&
        workerInfo.serviceScore > 0 &&
        workerInfo.workScore > 0
      "
    >
      <div class="h_title">
        <h2>孩子王考核官点评</h2>
      </div>
      <div class="evaluate_content">
        <div class="progress">
          <div class="progress_item">
            <span>技能掌握</span>
            <div class="progress_line">
              <div
                class="progress_line_value"
                :style="{ width: `${workerInfo.jnScore}%` }"
              ></div>
            </div>
          </div>
          <div class="progress_item">
            <span>职业素养</span>
            <div class="progress_line">
              <div
                class="progress_line_value"
                :style="{
                  width: `${workerInfo.serviceScore}%`
                }"
              ></div>
            </div>
          </div>
          <div class="progress_item">
            <span>工作能力</span>
            <div class="progress_line">
              <div
                class="progress_line_value"
                :style="{ width: `${workerInfo.workScore}%` }"
              ></div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="icon_left"><span></span></div>
          <div class="content_body">
            {{ workerInfo.checkerComment }}
          </div>
          <div class="icon_right"><span></span></div>
        </div>
      </div>
    </div>
    <!-- 孩子王考核官点评 end -->
    <!-- 荣誉锦旗 start -->
    <div class="newYuesaoC_box flag photo_wall" v-if="serviceImgList.length">
      <div class="h_title">
        <h2>
          荣誉锦旗
          <span v-if="serviceImgList.length > 3">
            {{ serviceImgList.length }}</span
          >
        </h2>
        <p class="flag-detail" @click="goFlagDetail(0)">
          查看详情
          <img src="../../../assets/images/sx_icon_more@3x.png" alt="" />
        </p>
      </div>
      <div class="photo_wall_content">
        <div class="photo_wall_items">
          <ul
            class=""
            ref="flag_wallul"
            @scroll="handlerTouchEnd($refs.flag_wallul, $refs.flag_wallline)"
          >
            <li
              v-for="(image, index) in serviceImgList"
              :key="index"
              @click="goFlagDetail(index)"
            >
              <Pnt
                :item="image"
                :timeCn="image.createdAt | stampToCn"
                :workerName="image.workerName"
              />
            </li>
          </ul>
        </div>
        <div class="photo_wall_line" v-if="serviceImgList.length >= 4">
          <div class="wall_line">
            <div class="line" ref="flag_wallline"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉锦旗 end -->

    <!--用户评价 start-->
    <div
      class="newYuesaoC_box userShortCommonts"
      v-if="memberComment && memberComment.total > 0"
    >
      <commentEnter
        :commentData="memberComment"
        :id="workerInfo.workerCode"
        :uid="workerInfo.uid"
        toAllComment="certified"
      ></commentEnter>
    </div>
    <!--用户评价 end-->

    <div class="newYuesaoC_box">
      <div class="h_title">
        <h2>服务流程</h2>
      </div>
      <img
        src="../../../assets/images/newYuesao/img_service_process@3x.png"
        alt=""
      />
    </div>
    <div class="newYuesaoC_box">
      <div class="h_title">
        <h2>服务保障</h2>
      </div>
      <img
        src="../../../assets/images/newYuesao/img_service_ensure@3x.png"
        alt=""
      />
    </div>

    <template v-if="isShowAction">
      <img
        class="floatButton-consult"
        @click="toYuerGuanjia"
        src="../../../assets/images/newYuesao/btn_consult.png"
      />
      <div class="rearActionNew menu_wkBox_back_box">
        <div class="buttons">
          <div class="left" @click="showConsultantPopup">
            <span>在线咨询</span>
          </div>
          <div class="right" @click="showEquityPopup">
            <div class="btn">预约面试</div>
          </div>
        </div>
      </div>
    </template>

    <imagePreview :items="previewImages"></imagePreview>
    <mt-popup v-model="skuListVisible" position="bottom">
      <CertifiedSkuList
        :workerInfo="workerInfo"
        @handleClose="
          () => {
            this.skuListVisible = false
          }
        "
      ></CertifiedSkuList>
    </mt-popup>

    <mt-popup v-model="wishFormVisible" position="bottom">
      <WishForm
        :cityAndLocationInfo="cityAndLocationInfo"
        @submitSuccess="hideWishForm"
        ref="ysWishForm"
        @submit="wishFormSubmit"
        @handleClose="
          () => {
            this.wishFormVisible = false
          }
        "
      ></WishForm>
    </mt-popup>

    <!--不要删除,兼容iphonex -->
    <div class="menu_wkBox_back_box"></div>
    <MockRouterAction ref="certificate">
      <CertificateDetail
        v-show="routerAction"
        :workerHiddenCredentials="workerInfo.workerHiddenCredentials"
      ></CertificateDetail>
    </MockRouterAction>
    <MockRouterAction ref="service">
      <serviceProcess
        v-show="routerAction"
        :serviceList="serviceList"
        :routerAction="routerAction"
      ></serviceProcess>
    </MockRouterAction>
    <MockRouterAction ref="flag">
      <flagDetail
        v-show="routerAction"
        :flagList="serviceImgList"
        :ysInfo="workerInfo"
        :flagActiveIndex="flagActiveIndex"
      ></flagDetail>
    </MockRouterAction>
    <van-popup
      v-model:show="isShowConsultantPopup"
      round
      position="bottom"
      safe-area-inset-bottom
      closeable
      :style="{ height: 'auto', background: '#f4f4f4' }"
    >
      <ConsultantContent
        :equity="commonYuesaoConf && commonYuesaoConf.equity"
        :content="content"
      />
    </van-popup>
    <van-popup
      v-model:show="isShowEquityPopup"
      round
      position="bottom"
      safe-area-inset-bottom
      closeable
      :style="{ height: 'auto' }"
    >
      <EquityContent
        :cityInfo="cityInfo"
        :equity="commonYuesaoConf && commonYuesaoConf.equity"
        @citySelected="citySelected"
        @submitSuccess="
          () => {
            isShowEquityPopup = false
          }
        "
      />
    </van-popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Popup from '@/components/action-sheet/popup'
import CertifiedSkuList from '@/components/rear/certifiedSkuList'
import CertificateDetail from './components/certificateDetail.vue'
import WishForm from '@/components/rear/wishForm'
import commentEnter from './components/comment'
import actionbar from '@/components/order/actionbar'
import imagePreview from '@/components/common/viewImage'
import { identityLabel } from '@/plugins/enum'
import MockRouterAction from '@/components/mockRouterAction/index.vue'
import certification from './components/certifications'
import serviceProcess from './components/serviceProcess.vue'
import flagDetail from './components/flagDetail.vue'
import Pennants from '@/components/evaluate/pennants'
import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import Pnt from '@/components/evaluate/pnt.vue'
import { getYcn } from '@/components/evaluate/utils'
import { Popup as VanPopup } from 'vant'
import { getLocation, getAPPLatAndLng } from '@/plugins/location'
import { isSKHYAPP } from '@/utils'
import {
  orderYuesao,
  createNeedFormService,
  createNeedFormData,
  yuesaoServiceInfo,
  yuesaoFlagInfo
} from '@/service/order/index'
import Cookie from 'js-cookie'
import utils from '@/plugins/utils'
import { Msgbox } from 'kf-component-vue'
import { setShare } from '@/plugins/share'
import ConsultantContent from './components/ConsultantContent/index'
import EquityContent from './components/EquityContent/index.vue'
import { getSelectedCity } from '@/plugins/city'
import { Toast } from 'vant'

export default {
  inject: {
    consultTrackParams: {
      default: null
    }
  },
  data() {
    return {
      isShowConsultantPopup: false,
      isShowEquityPopup: false,
      schedualAreasStr: [],
      serviceAreasName: [], // 服务区域名称
      uid: null,
      workerCredentials: [],
      memberComment: {},
      skuListVisible: false,
      wishFormVisible: false,
      popStatus: false,
      cityAndLocationInfo: {
        cityName: '南京',
        cityCode: '320100',
        curCityId: '',
        curDistrictId: '',
        lat: '',
        lng: ''
      },
      serviceList: [], // 服务动态列表
      serviceImgList: [], // 锦旗列表
      flagActiveIndex: 0, // 锦旗详情swiper当前索引下标值
      loading: true, // 加载中
      cityInfo: {},
      commonYuesaoConf: null,
      content: '',
      openConsult: 0
    }
  },
  async mounted() {
    this.$$loading(true)
    this.uid = this.$route.params.uid
    //获取月嫂权益配置
    this.getYueSaoCms()
    await this.getYuesaoServiceInfo()
    await this.getYuesaoFlagInfo()
    await this.getCmsContent()
    this.getMemberEvaluate()
    await this.getUserInfo()
    if (this.isNewSelfOpsSign) {
      this.setSelectedCityInfo()
    }
    this.setShareInfo()
    this.$$title('月嫂主页')
    this.$$loading(false)
    this.$nextTick(() => {
      this.setWallLineWidth(this.$refs.photo_wallul, this.$refs.photo_wallline)
      this.setWallLineWidth(this.$refs.flag_wallul, this.$refs.flag_wallline)
    })
    this.loading = false
    this.cityInfo = await getSelectedCity(true)
  },
  components: {
    commentEnter,
    CertifiedSkuList,
    WishForm,
    actionbar,
    imagePreview,
    'mt-popup': Popup,
    certification,
    CertificateDetail,
    MockRouterAction: MockRouterAction,
    serviceProcess,
    Pennants,
    flagDetail,
    Pnt,
    VanPopup,
    ConsultantContent,
    EquityContent
  },
  filters: {
    stampToCn(timestamp) {
      return getYcn(timestamp * 1000)
    }
  },
  computed: {
    ...mapState(['userInfo', 'previewImages', 'mainConfig']),
    workerInfo() {
      return this.userInfo.worker
    },
    identityLabelObj() {
      return identityLabel(this.workerInfo.userTypeName || '')
      // return identityLabel('三星月嫂' || '');
    },
    jnScore() {
      return `${workerInfo.jn_score}%`
    },
    isNewSelfOpsSign() {
      // WIKI signType:"1",//1联营签约月嫂；2自营签约月嫂(新)
      return this.userInfo.signType == 2
    },
    isShowAction() {
      return !isSKHYAPP()
    },
    routerAction() {
      if (!this.$route.query.hasOwnProperty('routerAction')) {
        this.$$title('月嫂主页')
        this.$$allowRefreshOrShare(true, true)
      } else {
        this.$$allowRefreshOrShare(false, false)
      }
      return this.$route.query.hasOwnProperty('routerAction')
    }
  },
  methods: {
    async setSelectedCityInfo() {
      // 获取不到宿主城市时取定位城市
      const city = (this.$$cookie('city_service') || '').split('_')[0]
      let resultCityCode = ''
      let resultCityName = ''
      let resultLat = ''
      let resultLng = ''
      let resultCurCityId = ''
      let resultCurDistrictId = ''
      console.debug("cookie('city_service')", city)
      if (city) {
        resultCityCode = city
      } else {
        resultCityCode = this.$$cookie('citycode') || ''
        console.debug("cookie('citycode')", this.$$cookie('citycode'))
      }

      if (this.$$isHZWApp()) {
        const { lat, lng } = getAPPLatAndLng()
        if (!resultCityCode) {
          resultCityCode = '320100'
        }
        resultLat = lat
        resultLng = lng
      } else {
        const { citycode, cityname, areaCode, lat, lng } = await getLocation()
        if (!resultCityCode) {
          resultCityName = cityname
          resultCurCityId = citycode
          resultCurDistrictId = areaCode
        }
        resultLat = lat
        resultLng = lng
      }

      this.cityAndLocationInfo.lat = resultLat
      this.cityAndLocationInfo.lng = resultLng
      this.cityAndLocationInfo.cityCode = resultCityCode
        ? changePrivinceCodeToCityCode(resultCityCode)
        : ''
      this.cityAndLocationInfo.curCityId = resultCurCityId
        ? changePrivinceCodeToCityCode(resultCurCityId)
        : ''
      this.cityAndLocationInfo.curDistrictId = resultCurDistrictId
      this.cityAndLocationInfo.cityName = resultCityName
      if (!resultCityName) {
        const res = await this.$store.dispatch('getNameById', {
          addressId: resultCityCode
        })
        if (res) {
          this.cityAndLocationInfo.cityName = res.NAME.replace('市', '')
        }
      }

      console.debug('setSelectedCityInfo', this.cityAndLocationInfo)
    },
    hideWishForm() {
      this.wishFormVisible = false
    },
    wishFormSubmit(params) {},
    gotoService(type) {
      let path = this.isNewSelfOpsSign
        ? 'ServiceDetailNewSelfOpsSign'
        : 'ServiceDetail'
      window.location.href = `//life.cekid.com/y/${path}?type=${
        type === 'ServiceDetail' ? 1 : 2
      }` // 服务介绍页面
    },
    showImage(images, index) {
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    setWallLineWidth(ul, line) {
      // 设置 this.$refs.photo_wallul宽度
      if (ul && line) {
        const initWidthPrecent = ul.offsetWidth / ul.scrollWidth
        line.style.width =
          line.parentElement.offsetWidth * initWidthPrecent + 'px'
      }
    },
    handlerTouchEnd(ul, line) {
      const percent = ul.scrollLeft / ul.scrollWidth
      line.style.transform = `translateX(${
        line.parentElement.offsetWidth * percent
      }px)`
    },
    showEquityPopup() {
      this.$$newTrackClick({
        bizType: '180',
        pageLevelId: '121012508',
        clickId: '200006',
        pageParam: {
          fuid: this.$$cookie('uid')
        },
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      })
      this.isShowEquityPopup = true
    },
    showConsultantPopup() {
      this.$$newTrackClick({
        bizType: '180',
        pageLevelId: '121012508',
        clickId: '200005',
        pageParam: {
          fuid: this.$$cookie('uid')
        },
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      })
      if (+this.openConsult) {
        let price = ''
        if (
          this.userInfo &&
          this.userInfo.signSku &&
          this.userInfo.signSku.length > 0
        ) {
          const sku = this.userInfo.signSku[0]
          price = `, 价格为${parseFloat(sku.price / 100)}/${sku.serviceDays}天`
        }
        this.content = `我想咨询孩子王甄选月嫂 ${this.workerInfo.workerName}, ${this.workerInfo.userTypeName}${price}`
        this.isShowConsultantPopup = true
      } else {
        Toast('非工作时间,建议您留下电话,我们稍后会致电您')
        this.isShowEquityPopup = true
      }
    },
    async getCmsContent() {
      try {
        const _d = this.workerInfo.workerCredentials.map(item => {
          return item.id
        })
        const res = await this.$$fetch(
          '//cms.cekid.com/publish/999/yshomepage.json'
        )
        const json = await res.json()
        if (json.code == 0 && json.data && json.data.workerCredentials) {
          let _Credentials = []
          json.data.workerCredentials.forEach(item => {
            // [22,12,7,5,24,4, 23, 21,3,9,1,]
            if (_d.includes(item.id)) {
              _Credentials.push(item)
            }
          })
          this.workerCredentials = _Credentials
        }
        // this.$$loading(false);
      } catch (e) {
        console.log(e)
      }
    },
    async getYueSaoCms() {
      try {
        const res = await this.$$fetch(
          '//cms.cekid.com/publish/999/newer-yuesao-home.json'
        )
        const json = await res.json()
        if (json.code == 0 && json.data) {
          this.openConsult = json.data.openConsult
          if (json.data.newSelfOpsConf) {
            if (json.data.newSelfOpsConf.length > 0) {
              this.commonYuesaoConf = json.data.newSelfOpsConf[0]
            }
          }
        }
        // this.$$loading(false);
      } catch (e) {
        console.log(e)
      }
    },
    citySelected(data) {
      this.cityInfo = data
    },
    async getMemberEvaluate() {
      const comment = await this.$store.dispatch('getNewCommentList', {
        page: 1,
        size: 2,
        workerCode: this.workerInfo.workerCode,
        type: 99,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        property: 2 // 短评
      })
      if (+comment.code === 1) {
        this.memberComment = comment.data
      }
    },
    toConfirmYuesao() {
      // 购买
      this.skuListVisible = true
    },
    isWorkTime() {
      const date = new Date()
      const isWorkday = date.getDay() % 6 !== 0
      const workingTime = date.getHours() >= 9 && date.getHours() <= 17
      return isWorkday && workingTime
    },

    // 跳转到月嫂心愿单
    toYuesaoWanted() {
      location.href = `https://life.cekid.com/y/yuesaowanted?swt=1&sourceparam={"canshu1":"rkjili"}`
    },
    // 跳转到育儿管家
    toYuerGuanjia() {
      if (this.$$isHZWApp()) {
        location.href = `https://w.cekid.com?cmd=parentingconsultanthome&isInHomePage=0`
      } else if (this.$$isRkhy()) {
        location.href = `kidswant://w.cekid.com?cmd=parentingconsultanthome&isInHomePage=0`
      } else {
        location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=parentingconsultanthome&isInHomePage=0` //app下载页
      }
    },
    showWishForm() {
      // 预约面试
      this.wishFormVisible = true
    },
    async getUserInfo() {
      try {
        const _arrName = []
        const areasArr = []
        const areasObjArr = []
        const areas = this.userInfo.area
        let isAll = false
        if (areas && areas.length > 0) {
          areas.forEach((v, i) => {
            if (
              v.cityId === '-1' &&
              v.provinceId === '-1' &&
              v.districtId === '-1'
            ) {
              isAll = true
              _arrName.push('全国')
            } else if (areasArr.indexOf(v.cityId) === -1) {
              areasArr.push(v.cityId)
              if (
                v.cityId === '110100' ||
                v.cityId === '120100' ||
                v.cityId === '310100' ||
                v.cityId === '500100'
              ) {
                _arrName.push(v.provinceName)
              } else {
                _arrName.push(v.cityName)
              }
            }
          })
          this.serviceAreasName = _arrName
          if (isAll) {
            this.schedualAreasStr.push('全国')
          } else {
            areasArr.forEach((v1, i1) => {
              areasObjArr[i1] = []
              areas.forEach((v2, i2) => {
                if (v2.cityId === v1) {
                  const obj = {}
                  if (
                    v2.cityId === '110100' ||
                    v2.cityId === '120100' ||
                    v2.cityId === '310100' ||
                    v2.cityId === '500100'
                  ) {
                    obj.cityName = v2.provinceName
                  } else {
                    obj.cityName = v2.cityName
                  }
                  obj.districtName = v2.districtName
                  areasObjArr[i1].push(obj)
                }
              })
            })
            areasObjArr.forEach((v, i) => {
              let str = ''
              const dist = []
              v.forEach((v1, i1) => {
                if (i1 === 0) {
                  str += `${v1.cityName}：`
                }
                dist.push(v1.districtName)
              })
              str += dist.join('.')
              this.schedualAreasStr.push(str)
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    correctIsLogin(url) {
      let uid = Cookie.get('uid')
      let skey = Cookie.get('skey')
      if (uid && skey) {
        return { uid, skey }
      } else {
        const refer_url = url || location.href
        location.href = `//passport.cekid.com/passport/login?cmd=login&referer=${encodeURIComponent(
          refer_url
        )}`
      }
    },
    async toOrder($event, appointStatus) {
      // 老育儿页面一键预约
      const { uid, skey } = await this.correctIsLogin()
      if (!uid || !skey) return
      if (appointStatus) return
      try {
        const { uid, workerCode, cityName } = this.userInfo.worker
        const res = await orderYuesao({
          workerCode,
          uid,
          memberUid: this.$$cookie('uid') || '',
          cityId: this.userInfo.signSku[0].cityId,
          cityName
        })
        if (res && res.code === '1') {
          this.userInfo.appointStatus = 1
          Msgbox({
            title: '预约成功',
            message: `请您稍等片刻~</br>我们正在安排月嫂和您沟通哦!`,
            showCancelButton: false,
            confirmButtonText: '我知道了'
          })
        }
      } catch (e) {
        this.$$toast('系统发生异常')
        console.log(e)
      }
    },
    async getYuesaoServiceInfo() {
      const params = {
        workerCode: this.userInfo.worker.workerCode,
        startPage: 1,
        pageSize: 100 // 数据数量小， 暂定传100获取所有数据
      }

      const res = await yuesaoServiceInfo(params)
      if (res && res.errno === 0 && res.data) {
        this.serviceList = res.data
      }
    },
    async getYuesaoFlagInfo() {
      const params = {
        workerCode: this.userInfo.worker.workerCode,
        startPage: 1,
        pageSize: 1000 // 数据数量小， 暂定传1000获取所有数据
      }
      const res = await yuesaoFlagInfo(params)
      if (res && res.errno === 0 && res.data) {
        this.serviceImgList = res.data
      }
    },
    goCredentialsDetail() {
      this.$router.push({
        query: {
          ...this.$route.query,
          routerAction: ''
        }
      })
      this.$refs.certificate.show()
      this.$$title('持有证书')
    },
    goServiceDetail() {
      this.$router.push({
        query: {
          ...this.$route.query,
          routerAction: ''
        }
      })
      this.$refs.service.show()
      this.$$title('全部服务记录')
    },
    goFlagDetail(index) {
      this.flagActiveIndex = index
      this.$router.push({
        query: {
          ...this.$route.query,
          routerAction: ''
        }
      })
      this.$refs.flag.show()
      this.$$title('锦旗荣誉墙')
    },
    setShareInfo() {
      const __link = location.href
      setShare({
        channel: '2,3,5,6,7,8,15',
        // userName: 'gh_362b01c44275', // 孩子王小程序
        // 全角空格，普通空格微信分享卡片中不生效
        title: `甄选月嫂　${this.workerInfo.workerName}主页`,
        desc: `${this.identityLabelObj.name}　${this.workerInfo.age}岁｜${this.workerInfo.place}｜${this.workerInfo.workAge}年从业经验`,
        imgUrl: this.workerInfo.headImage,
        path: `/pages/mall-index/index?refererH5=${encodeURIComponent(
          location.href
        )}`,
        dpH5: 1,
        dpinfoH5: JSON.stringify({
          imageurl: this.workerInfo.headImage, // 海报里的主图，1:1，多规格商品图用逗号分割
          product_name: `${this.identityLabelObj.name}　${this.workerInfo.workerName}主页`,
          price_name: `${this.workerInfo.age}岁｜${this.workerInfo.place}｜${this.workerInfo.workAge}年从业经验`, // 价格名称，非必传
          price: this.userInfo.signSku[0].price, // 价格，单位分，非必传
          tags: [`${this.userInfo.signSku[0].serviceDays}天`],
          link: location.href,
          path: location.href
        }),
        page: '/pages/mall-index/index',
        scene: `$$ENCODE(${encodeURIComponent(location.href)})`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/mixin';
@import './index.scss';
</style>

<style lang="scss">
@import '../../../assets/css/mixin';
.pic-swipe-wrapper {
  z-index: 100 !important;
}

.hzw-root .kfcv-msgbox .kfcv-msgbox-confirm {
  color: #ff397e;
}
</style>
